import { getOrigin } from './getOrigin'

export default class HttpRequest {
  private static _origin: string | null = null;
  constructor() {
    this.fetcher = this.fetcher.bind(this);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async fetcher<T = any>(options: string | { url: string; method: Request["method"]; body?: string, headers?: Headers }) {
    const origin = await getOrigin();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    origin !== HttpRequest._origin && (HttpRequest._origin = origin);
    let request: Request;
    if (typeof options === 'string') {
      request = new Request(`${options.startsWith('http') ? '' : origin + '/api'}${options}`, {
        method: 'get',
      })
    } else {
      const { url, ...rest } = options;
      request = new Request(`${url.startsWith('http') ? '' : origin + '/api'}${url}`, { ...rest })
    }
    const res = await fetch(request)
    if (res.ok) {
      return await res.json() as T
    }
    throw new Error(`Request failed ${res.status}: ${res.statusText}`)
  }
}